import { connect } from "react-redux";
import { Link } from "react-router-dom";

const SchemeErrorsRow = ({ error, fullName, isLast }) => {
	if (!error) return null;

	return (
		<div
			style={{
				display: "grid",
				gridGap: "1.5rem",
				grid: "1.5rem",
				gridTemplateColumns: "repeat(10, minmax(0, 1fr))",
				padding: "1rem",
				borderBottom: isLast ? undefined : "solid rgb(244,244,244) 4px",
			}}
		>
			<div style={{ gridColumn: "span 2 / span 10", textAlign: "center", opacity: "0.75" }}>
				{!error.url ? (
					<h5>{error.reference}</h5>
				) : (
					<a
						href={error.url}
						target="_blank"
					>
						{error.reference}
					</a>
				)}
			</div>
			<div style={{ gridColumn: "span 4 / span 10", textAlign: "center", opacity: "0.75" }}>
				<h5>{error.message}</h5>
			</div>
			<div style={{ gridColumn: "span 2 / span 10", textAlign: "center", opacity: "0.75" }}>
				{error.agreement ? <Link to={`/organisation/people/${error.agreement}`}>{fullName}</Link> : null}
			</div>
			<div style={{ gridColumn: "span 1 / span 10", textAlign: "center", opacity: "0.75" }}>
				<h5>{error.expectedValue}</h5>
			</div>
			<div style={{ gridColumn: "span 1 / span 10", textAlign: "center", opacity: "0.75" }}>
				<h5>{error.providedValue}</h5>
			</div>
		</div>
	);
};

const mapStateToProps = (state, { error }) => {
	const employees = state.employees?.employeeList;

	console.debug(
		employees?.find((employee) => employee.id == error.agreement),
		error.agreement,
		employees,
	);

	const { givenName, familyName } =
		employees?.find((employee) => employee.id == error.agreement)?.employeeDetails || {};

	const fullName = `${givenName} ${familyName}`;

	return {
		fullName,
		disabled: state?.permissions?.my?.permissions?.payroll == "Read",
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SchemeErrorsRow);
